import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import { Divider } from 'material-ui';
import debounce from 'lodash.debounce';
import NoteContent from '../notes/note-content';
import CommentBox from './generic-components/comment-box';
import { sendMessage, addFilesToContract } from '../workspace/store/actions';
import { getNotes } from './__storeFiles__/actions';


const styles = {
  container: {
    backgroundColor: 'rgb(240, 244, 247)',
    height: 'calc(100vh - 268px)',
    paddingLeft: '0 !important',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  containerSupplier: {
    height: 'calc(100vh - 168px) !important',
  },
  workspaceContent: {
    backgroundColor: 'white',
    flex: '1 1 auto',
    overflowX: 'hidden',
    overflowY: 'scroll',
    padding: '8px 2%',
  },
};

class NotesInContracting extends Component {
  constructor(props) {
    super(props);
    this.defaultState = { // don't include object in values
      currentComment: '',
      disableSend: false,
      attachedFiles: [],
    };
    this.state = Object.assign({}, this.defaultState);
  }
  componentDidMount() {
    // load the internal notes content
    // this.props.changeSelection(urlVals.connectionId, 'notes', urlVals.contractId);
    if (this.props.body.length > 0) this.scrollToBottom();
    else this.props.getNotes();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.messageCreating && !this.state.disableSend) {
      // sending to server
      this.setState({ disableSend: true });
    }
    if (!nextProps.messageCreating && this.state.disableSend) {
      // message has been sent !
      this.setState({ disableSend: false });
      if (!nextProps.messageCreateError) {
        // and no error, wow
        this.setState(this.defaultState);
        this.clearInput();
      }
    }
    if (this.props.loading && !nextProps.loading && nextProps.body.length !== this.props.body.length) {
      this.scrollToBottom();
    }
  }
  // shouldComponentUpdate(nextProps, nextState) {
  //   return !R.equals(this.props.body, nextProps.body) || !R.equals(this.state, nextState);
  // }
  handleComment = (input) => {
    this.setState({ currentComment: input });
  }
  handleCancel = () => {
    this.setState({ currentComment: '' });
    this.setState({ disableSend: false });
    this.clearInput();
  }
  submitComment = () => {
    this.setState({ disableSend: true }, () => {
      this.props.sendMessage({
        contractHFIds: [this.props.historyFeed],
        type: 'note',
        messageText: this.state.currentComment,
        files: this.state.attachedFiles,
      });
    });
  }
  handleAttachFile = (fileList) => {
    this.setState({ attachedFiles: fileList });
  }
  conversationDOM = () => document.getElementsByClassName('conversation')[0];
  scrollToBottom = debounce(() => {
    const container = this.conversationDOM();
    if (container) container.scrollTop = (container.scrollHeight - container.clientHeight);
  }, 100);
  render() {
    const { body, classes, companyType } = this.props;
    return (
      <div className={`${classes.container}${(companyType === 'Supplier' ? ` ${this.props.classes.containerSupplier}` : '') }`}>
        <div className={`conversation ${classes.workspaceContent}`}>
          { body.map(message => <NoteContent
            key={message.messageId}
            itemId={message.messageId}
            bodyText={message.bodyText}
            bodyJson={message.bodyJson}
            attachments={message.attachments}
            authorname={message.creatorMeta.name || message.creatorEmail}
            timestamp={message.createdAt}
            handleRemove={this.props.deleteMessage}
            handleAddToContract={this.props.addFilesToContract}
            disallowAddToContract={(companyType === 'Supplier')}
            disabled={(message.disabled || false)}
          />)}
        </div>
        <Divider />
        <CommentBox
          comment={this.state.currentComment}
          handleInput={this.handleComment}
          attachFile={this.handleAttachFile}
          attachedFiles={this.state.attachedFiles}
          submitComment={this.submitComment}
          cancelComment={this.handleCancel}
          setClear={clear => this.clearInput = clear}
          // setFocus: PropTypes.func,
          disableSend={this.state.disableSend}
          internal
        />
      </div>
    );
  }
}

NotesInContracting.propTypes = {
  body: PropTypes.array,
  buyerId: PropTypes.string,
  changeSelection: PropTypes.func,
  classes: PropTypes.object,
  companyType: PropTypes.string,
  loading: PropTypes.bool,
  historyFeed: PropTypes.string,
  messageCreateError: PropTypes.bool,
  messageCreating: PropTypes.bool,
  sendMessage: PropTypes.func,
  suppplierId: PropTypes.string,
  deleteMessage: PropTypes.func,
  addFilesToContract: PropTypes.func,
  partnerId: PropTypes.string,
  getNotes: PropTypes.func,
};

NotesInContracting.defaultProps = {
  body: [],
};


export default connect(({ workspace, user, contracting }) => ({
  body: contracting.contractActivitiesProducts.get('notes').toJS(),
  messageCreating: workspace.messageCreating,
  messageCreateError: workspace.messageCreateError,
  loading: workspace.conversationsFetching,
  companyType: user.getIn(['user', 'type']),
  historyFeed: contracting.contractActivitiesProducts.getIn(['leftNav', 'historyFeedId']),
  supplierId: contracting.contractActivitiesProducts.getIn(['leftNav', 'supplierId']),
  buyerId: contracting.contractActivitiesProducts.getIn(['leftNav', 'buyerId']),
  email: contracting.contractActivitiesProducts.getIn(['leftNav', 'email']),
}), {
  getNotes,
  sendMessage,
  deleteMessage: payload => ({ type: '{contract} DELETE_CONTRACT_NOTE', payload }),
  addFilesToContract,
})(injectSheet(styles)(NotesInContracting));



// WEBPACK FOOTER //
// ./src/app/components/contracting/notes.jsx